import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography } from '@mui/material';
import SideDish from '@components/offer/models/SideDish';
import Amount from '@components/common/molecules/Amount';

interface SideDishAmountProps {
    sideDish: SideDish;
}

const SideDishAmount: React.FC<SideDishAmountProps> = observer(({ sideDish }) => {
    if (sideDish.displayAmount === undefined || sideDish.displayAmount === false) {
        return null;
    }
    return (
        <Box ml={0.5} display={"flex"} flexDirection={"row"} alignItems={"center"}>
            <Typography variant='caption' fontWeight={600}>(+</Typography>
            <Amount amount={sideDish.price} variant='caption' fontWeight={600} />
            <Typography variant='caption' fontWeight={600}>)</Typography>
        </Box>
    )
})

export default SideDishAmount;